import Vue from 'vue'
//1.导入路由组件vue-router
import Router from 'vue-router'
// import HeaderPart from "../components/HeaderPart.vue"
import HelloWorld from "../components/HelloWorld.vue"
import HelloWorld2 from "../components/HelloWorld2.vue"
import HelloWorld3 from "../components/HelloWorld3.vue"
import HelloWorld4 from "../components/HelloWorld4.vue"
import HelloWorld5 from "../components/HelloWorld5.vue"
//2.调用vue-router
Vue.use(Router)
//3.创建vue-router实例
const router = new Router({
	routes: [
		// {
		// 	path: "/",
		// 	name: "index",
		// 	component: HeaderPart,
		// 	children: [{
		// 			path: "/HelloWorld",
		// 			component: HelloWorld
		// 		},
		// 		{
		// 			path: "/HelloWorld2",
		// 			component: HelloWorld2
		// 		}
		// 	]
		// }, 
		{
			path: '/',
			name: "index",
			meta: {
			    title: '广州维握信息科技有限公司'
			},
			component: HelloWorld
		},
		{
			path: '/cpfw',
			name: "cpfw",
			meta: {
			    title: '广州维握信息科技有限公司'
			},
			component: HelloWorld2
		},
		{
			path: '/khal',
			name: "khal",
			meta: {
			    title: '广州维握信息科技有限公司'
			},
			component: HelloWorld3
		},
		{	
			path: '/gywm',
			name: "gywm",
			meta: {
			    title: '广州维握信息科技有限公司'
			},
			component: HelloWorld4
		},
		{
			path: '/lxfs',
			name: "lxfs",
			meta: {
			    title: '广州维握信息科技有限公司'
			},
			component: HelloWorld5
		},
	],
		scrollBehavior(to) {
		  if (to.hash) {		
		    return new Promise(resolve => {
		      setTimeout(() => {
		        const element = document.querySelector(to.hash);
		        if (element) {
		          const top = element.offsetTop - 100; // 手动计算偏移
		          window.scrollTo({ top, behavior: 'smooth' });
		        }
		        resolve();
		      }, 1000);
		    });
		  }else {
			return { x: 0, y: 0 }; 
		  }
		}
});
export default router;